module.exports = __webpack_public_path__ + "static/media/muvnday_logo_white.0a5b0866.png";